import { render, staticRenderFns } from "./youxibi.vue?vue&type=template&id=3256989c"
import script from "./youxibi.vue?vue&type=script&lang=js"
export * from "./youxibi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports